<template>
    <v-container fluid>
        <new-machine-model-form @create="create"></new-machine-model-form>
    </v-container>
</template>
<script>
import NewMachineModelForm from './NewMachineModelForm.vue';
export default {
    name: 'NewMachineModel',
    props: {},
    components: { NewMachineModelForm },

    data() {
        return {};
    },

    methods: {
        create(val) {
            this.$router.push({ name: 'ViewMachineModelInfo', params: { modelId: val } });
        }
    },

    computed: {},

    watch: {},
};
</script>


<style lang='scss' scoped></style>